import React from 'react';
import i18n from '../../../../i18n';
import {
  getAuction,
  addViewCount,
  toggleWishlist,
  toggleLike,
  toggleCalendar,
  getActiveAuctions,
  getTodayEndAuctions,
} from '../../../../models/auctions';
import { SkeletonAuctionDetails } from '../../../helpers/skeletons/skeletonAuctionDetails';
import { formatCurrency } from '../../../../state/utils';
import { Helmet } from 'react-helmet';
import { baseUrl } from '../../../../constants/global';
import swal from 'sweetalert';
import getServerTime from '../../../../models/server';
import '../../../../styles/components/auction-preview.scss';
import '../../../../styles/components/auction-card-real-estate.scss';
import '../../../../styles/components/auction-details.scss';
import { BiddingCompNew } from './components/BiddingComp';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';
import AuctionCardNew from '../../components/Auction/AuctionCard';
import AuctionGroupCardNew from '../../components/Auction/AuctionGroupCard';
import { OmrRiyal } from '../../../common/icons';
import AuctionAttachments from './components/AuctionAttachments';
import CarouselAuctionDetails from './components/Carouselauctiondetails';
import PropertyDetails from './components/Propertydetails';
import { getActiveEnrolled } from '../../../../models/groups';
import { useLocation, useParams } from 'react-router-dom';

let is_logged = localStorage.getItem('is_logged_in') ? true : false;
let current_lng = localStorage.getItem('I18N_LANGUAGE');

export class AuctionDetailsNew extends React.Component {
  constructor(props) {
    super(props);
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf('/') + 1, path.length);
    this.state = {
      // ── Detail page state (same as old AuctionDetails) ──
      wishlist: false,
      like: false,
      calendar: false,
      auctionId: auctionId,
      auction: [],
      toggleArrow: false,
      bid_increment: 0,
      current_bid_amount: 0,
      user_bid_amount: 0,
      left_button_disable: true,
      is_bid_sending: false,
      bid_place_message: '',
      enquiries: [{ label: '', value: '' }],
      is_loading: false,
      bidTimeStopped: false,
      now: () => {
        let time = new Date().toLocaleTimeString('en-US', { timeZone: 'Asia/Muscat' });
        let dt = new Date().toISOString('en-US').split('T')[0];
        let newDt = dt + ' ' + time;
        newDt = new Date(newDt.replace(/-/g, '/'));
        return newDt;
      },

      // ── Slider state ──
      activeType: 'real_estate',
      realEstateAuctions: [],
      regularAuctions: [],
      sliderLoading: false,
      currentIndex: 0,
      visibleCount: 3,
      attributes: [],
      enrolledAuctions: [],
      enrolledLoading: false,
      todayAuctions: [],
      todayLoading: false,
      isMobile: window.innerWidth <= 768,
    };

    this.updateMetaTags = this.updateMetaTags.bind(this);
    this.addWishList = this.addWishList.bind(this);
    this.addLike = this.addLike.bind(this);
    this.addCalendar = this.addCalendar.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  // ══════════════════════════════════════════════════════════════════════
  //  LIFECYCLE — same as old AuctionDetails + slider extras
  // ══════════════════════════════════════════════════════════════════════

  componentDidMount() {
    window.scrollTo(0, 0);
    this.addViewCount();
    this.loadAuction();
    this.setServerTime();

    // Slider extras
    this.loadAuctions();
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    if (is_logged) {
      this.loadEnrollAuctions();
    }
    this.loadTodayAuctions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    const prevId = prevProps.match?.params?.id || prevProps.location?.pathname?.split('/').pop();
    const nextId = this.props.match?.params?.id || this.props.location?.pathname?.split('/').pop();

    if (prevId && nextId && prevId !== nextId && prevState.auctionId !== nextId) {
      this.setState(
        {
          auctionId: nextId,
          auction: [],
          is_loading: true,
          currentIndex: 0,
          attributes: [],
          enrolledAuctions: [],
          realEstateAuctions: [],
          regularAuctions: [],
          wishlist: false,
          like: false,
          calendar: false,
        },
        () => {
          window.scrollTo(0, 0);
          this.addViewCount();
          this.loadAuction();
          this.setServerTime();
          this.loadAuctions();
          if (is_logged) {
            this.loadEnrollAuctions();
          }
          this.loadTodayAuctions();
        }
      );
    }
  }

  // ══════════════════════════════════════════════════════════════════════
  //  CORE FUNCTIONS — exactly matching old AuctionDetails
  // ══════════════════════════════════════════════════════════════════════

  async setServerTime() {
    try {
      let response = await getServerTime();
      let serverTime = new Date(response.server_time.replace(/-/g, '/'));
      this.setState({ now: () => serverTime });
    } catch (error) {
      console.error('Error fetching server time:', error);
    }
  }

  updateMetaTags(auction) {
    let { id, title, images, description } = auction;

    let first_image = images && images.length > 0 ? images[0].image : false;
    let url = baseUrl + 'auction-details/' + id;

    const updatedMetaTags = [
      { property: 'og:title', content: title },
      { property: 'og:type', content: 'Auctions' },
      { property: 'og:url', content: url },
      { property: 'og:site_name', content: 'Mzadcom' },
      { property: 'og:description', content: description },
      { property: 'og:image', content: first_image },
      { name: 'twitter:card', content: 'app' },
      { name: 'twitter:title', content: 'Mzadcom Auctions' },
      { name: 'twitter:text:title', content: 'Mzadcom Auctions' },
      { name: 'twitter:image', content: first_image },
      { name: 'twitter:description', content: description },
    ];

    return (
      <Helmet>
        <title>{title}</title>
        {updatedMetaTags.map((tag, index) => (
          <meta key={index} {...tag} />
        ))}
      </Helmet>
    );
  }

  async addViewCount() {
    await addViewCount({ auction_id: this.state.auctionId });
  }

  async loadAuction() {
    this.setState({ is_loading: true });
    let id = this.state.auctionId;
    const response = await getAuction(id);
    if (response) {
      let auction = response.data;
      let enquiry = auction.enquiry;
      auction.selected_mask = auction.mask;
      this.setState({
        auction: auction,
        current_bid_amount: auction.start_amount,
        enquiries: enquiry,
        is_loading: false,
      });
      this.setState({ like: auction.auction_liked });
      this.setState({ wishlist: auction.auction_wishlisted });
      this.setState({ calendar: auction.calendar });
      this.setState({ attributes: auction?.attributes });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async addWishList(wishlist) {
    let { auction } = this.state;
    if (is_logged) {
      const response = await toggleWishlist({
        auction_id: auction.id,
        wishlist,
      });
      if (response) {
        this.setState({ wishlist: wishlist });
      }
    }
  }

  async addLike(like) {
    let { auction } = this.state;
    if (is_logged) {
      const response = await toggleLike({
        auction_id: auction.id,
        like,
      });
      if (response) {
        this.setState({ like: like });
      }
    }
  }

  async addCalendar(calendar) {
    let { auction } = this.state;
    if (is_logged) {
      const response = await toggleCalendar({
        auction_id: auction.id,
        calendar,
      });
      if (response) {
        this.setState({ calendar: calendar });
        if (calendar) {
          swal('Success', i18n.t('added_to_calendar'), 'success');
        } else {
          swal('Success', i18n.t('removed_from_calendar'), 'success');
        }
      }
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, '/')) : null;
  }

  updateCurrentAmount = (amount) => {
    this.setState((prevState) => ({
      auction: {
        ...prevState.auction,
        current_amount: amount,
      },
    }));
  };

  // ══════════════════════════════════════════════════════════════════════
  //  SLIDER FUNCTIONS
  // ══════════════════════════════════════════════════════════════════════

  async loadAuctions() {
    this.setState({ sliderLoading: true });
    try {
      const response = await getActiveAuctions('limit=30');
      const allAuctions = response?.data || [];

      const realEstate = allAuctions.filter(
        (a) =>
          a.category_name?.toLowerCase().includes('real') ||
          a.category_name?.toLowerCase().includes('estate') ||
          a.category_name?.toLowerCase().includes('apartment') ||
          a.category_name?.toLowerCase().includes('property') ||
          a.is_real_estate === true ||
          a.is_real_estate === 1
      );

      const regular = allAuctions.filter((a) => !realEstate.includes(a));

      this.setState({
        realEstateAuctions: realEstate.length > 0 ? realEstate : allAuctions.slice(0, 10),
        regularAuctions: regular.length > 0 ? regular : allAuctions,
        sliderLoading: false,
      });
    } catch (e) {
      console.error('Error loading auctions:', e);
      this.setState({ sliderLoading: false });
    }
  }

  handleResize() {
    const w = window.innerWidth;
    let visibleCount = 3;
    if (w <= 600) visibleCount = 1;
    else if (w <= 992) visibleCount = 2;
    this.setState({
      visibleCount,
      currentIndex: 0,
      isMobile: w <= 768,
    });
  }

  sortByOrder(data) {
    if (!data || !data.length) return [];
    return [...data].sort((a, b) => (a.order || 0) - (b.order || 0));
  }

  getActiveAuctions() {
    const data =
      this.state.activeType === 'real_estate'
        ? this.state.realEstateAuctions || []
        : this.state.regularAuctions || [];
    return this.sortByOrder(data);
  }

  slideNext = () => {
    const auctions = this.getActiveAuctions();
    const max = Math.max(0, auctions.length - this.state.visibleCount);
    this.setState((s) => ({ currentIndex: Math.min(s.currentIndex + 1, max) }));
  };

  slidePrev = () => {
    this.setState((s) => ({ currentIndex: Math.max(s.currentIndex - 1, 0) }));
  };

  // ══════════════════════════════════════════════════════════════════════
  //  ENROLLED & TODAY AUCTIONS
  // ══════════════════════════════════════════════════════════════════════

  normalizeAuction(auc) {
    return {
      ...auc,
      status_dis: auc.status_dis || auc.status || 'A',
      current_amount: auc.latest_bid?.bid_amount || auc.current_amount || auc.start_amount || 0,
      bid_count: auc.bidders_count || auc.bid_count || 0,
      images: auc.images || [],
      server_time:
        auc.server_time ||
        new Date().toLocaleString('en-US', { timeZone: 'Asia/Muscat' }).replace(',', ''),
      start_date_formatted: auc.start_date_formatted || auc.start_date || '',
      end_date_formatted: auc.end_date_formatted || auc.end_date || '',
      total_views: auc.total_views || 0,
      is_a_group: auc.is_a_group || false,
      is_enrolled: true,
      category_name: auc.category_name || '',
      organizationDetails: auc.organization_relation
        ? {
          organization_name: auc.organization_relation.organization_name,
          organization_name_ar: auc.organization_relation.organization_name_ar,
          organization_image_url: auc.organization_relation.organization_image_url,
          file_organization_image_full: auc.organization_relation.organization_image_url,
        }
        : auc.organizationDetails || null,
      group_name: auc.group_relation?.group_name || auc.group_name || '',
      group_name_ar: auc.group_relation?.group_name_ar || auc.group_name_ar || '',
      my_rank: auc.my_rank || null,
    };
  }

  async loadEnrollAuctions() {
    this.setState({ enrolledLoading: true });
    try {
      const response = await getActiveEnrolled('limit=100');
      if (response && response.data) {
        const normalized = response.data.map((auc) => this.normalizeAuction(auc));
        this.setState({ enrolledAuctions: normalized, enrolledLoading: false });
      } else {
        this.setState({ enrolledLoading: false });
      }
    } catch (e) {
      console.error('Error loading enrolled auctions:', e);
      this.setState({ enrolledLoading: false });
    }
  }

  async loadTodayAuctions() {
    this.setState({ todayLoading: true });
    try {
      const response = await getTodayEndAuctions('limit=100');
      if (response && response.data) {
        const normalized = response.data.map((auc) => this.normalizeAuction(auc));
        this.setState({ todayAuctions: normalized, todayLoading: false });
      } else {
        this.setState({ todayLoading: false });
      }
    } catch (e) {
      console.error('Error loading today auctions:', e);
      this.setState({ todayLoading: false });
    }
  }

  // ══════════════════════════════════════════════════════════════════════
  //  RENDER HELPER — auction slider section
  // ══════════════════════════════════════════════════════════════════════

  renderSliderSection(title, auctions, count) {
    const { currentIndex, visibleCount } = this.state;
    const slideWidth = 100 / visibleCount;
    const translateX = -(currentIndex * slideWidth);
    const maxIdx = Math.max(0, auctions.length - visibleCount);

    return (
      <div className="ad-related-section">
        <div style={{ textAlign: 'center' }}>
          <h2 className="ad-related-title">
            {title} &nbsp;
            <span className="re-auc-topline__bids">{count}</span>
          </h2>
        </div>

        <div className="as-slider-outer">
          <button className="as-arrow as-arrow--left" onClick={this.slidePrev} disabled={currentIndex === 0}>
            <ChevronLeft size={18} />
          </button>

          <div className="as-slider-track-wrap">
            <div className="as-slider-track" style={{ transform: `translateX(${translateX}%)` }}>
              {auctions.map((auc, i) =>
                !auc.is_a_group ? (
                  <div key={auc.id || i} className="as-slide">
                    <AuctionCardNew auction={auc} auctionId={auc.id} />
                  </div>
                ) : (
                  <div key={i} className="as-slide">
                    <AuctionGroupCardNew
                      group={auc}
                      total_items={auctions.length}
                      can_bid={false}
                      type={this.props.type}
                    />
                  </div>
                )
              )}
            </div>
          </div>

          <button className="as-arrow as-arrow--right" onClick={this.slideNext} disabled={currentIndex >= maxIdx}>
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    );
  }

  // ══════════════════════════════════════════════════════════════════════
  //  RENDER
  // ══════════════════════════════════════════════════════════════════════

  render() {
    let auction = this.state.auction;

    const { isMobile } = this.state;


    let action_name = current_lng === 'ar' ? auction.title_ar : auction.title;
    let auction_images = auction.images;

    let startDateAr = auction.start_date_ar;
    let endDateAr = auction.end_date_ar;

    let category_name =
      current_lng === 'ar'
        ? auction?.categoryDetails?.category_name_ar
        : auction?.categoryDetails?.category_name;

    let end_time = endDateAr && endDateAr['time'] ? endDateAr['time'] : '';
    end_time = end_time.replace('PM', i18n.t('PM'));
    end_time = end_time.replace('AM', i18n.t('AM'));

    let start_time = startDateAr && startDateAr['time'] ? startDateAr['time'] : '';
    start_time = start_time.replace('PM', i18n.t('PM'));
    start_time = start_time.replace('AM', i18n.t('AM'));

    let updatedMetaTags = '';
    if (auction && auction.id) {
      updatedMetaTags = this.updateMetaTags(auction);
    }

    // Status badge
    const statusMap = {
      A: { cls: 're-auc-badge--active', lbl: i18n.t('active') || 'Active' },
      E: { cls: 're-auc-badge--expired', lbl: i18n.t('expired') || 'Expired' },
      U: { cls: 're-auc-badge--upcoming', lbl: i18n.t('upcoming') || 'Upcoming' },
      F: { cls: 're-auc-badge--featured', lbl: i18n.t('featured') || 'Featured' },
    };
    const statusEntry = statusMap[auction.status_dis] || statusMap['A'];

    // Slider variables
    const { currentIndex, visibleCount, sliderLoading } = this.state;
    const sliderAuctions = this.getActiveAuctions();
    const totalSlides = sliderAuctions.length;
    const maxIndex = Math.max(0, totalSlides - visibleCount);
    const slideWidth = 100 / visibleCount;
    const translateX = -(currentIndex * slideWidth);
    const dotCount = Math.max(0, totalSlides - visibleCount + 1);

    return (
      <React.Fragment>
        <div className="adn-page mb-5">
          {updatedMetaTags}

          {/* ── LOADING ── */}
          {this.state.is_loading && (
            <div className="text-center p-5">
              <SkeletonAuctionDetails />
            </div>
          )}

          {!this.state.is_loading && auction && Object.keys(auction).length > 0 && (
            <>
              <section className="adn-section">
                <div className="container as-slider-outer">
                  <div className="adn-main-grid">

                    {/* ── LEFT COLUMN ── */}
                    <div>
                      {/* Hero */}
                      <div className="adn-hero container">
                        <div className="adn-title-bar">
                          <div>
                            <h2 className="adn-page-title">{action_name}</h2>
                          </div>
                        </div>

                        {auction_images && auction_images.length > 0 ? (
                          <div className="adn-hero-gallery-wrap">
                            <CarouselAuctionDetails images={auction_images} />
                            <span className={`re-auc-badge adn-hero-status ${statusEntry.cls}`}>
                              {statusEntry.lbl}
                            </span>
                            <div className="adn-hero-id-pill">
                              {i18n.t('MZAD')}
                              {auction.id}
                            </div>
                          </div>
                        ) : (
                          <div className="adn-hero-img-wrap">
                            <img
                              src={process.env.PUBLIC_URL + '/assets/images/placeholder.jpg'}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          </div>
                        )}
                      </div>

                      {/* Mobile — primary only on mobile screens */}
                      <div className="adn-hidden-md">
                        <BiddingCompNew
                          auction={auction}
                          lng={current_lng}
                          onAmountUpdate={this.updateCurrentAmount}
                          isPrimary={isMobile}
                        />
                      </div>

                      {/* ── Info strip — dates ── */}
                      <div className="adn-info-strip container adn-info-strip--3col">
                        {/* Start Date */}
                        <div className="adn-panel">
                          <div className="adn-panel-header">{i18n.t('start_date')}</div>
                          <div className="adn-panel-body">
                            <div className="adn-date-weekday">
                              {startDateAr && startDateAr['day'] ? i18n.t(startDateAr['day']) : ''}
                            </div>
                            <div className="adn-date-value">
                              <Calendar size={18} />
                              {startDateAr && startDateAr['date'] ? startDateAr['date'] : '—'}
                            </div>
                            <div className="adn-date-time-val">({start_time})</div>
                          </div>
                        </div>

                        {/* End Date */}
                        <div className="adn-panel">
                          <div className="adn-panel-header">{i18n.t('end_date')}</div>
                          <div className="adn-panel-body">
                            <div className="adn-date-weekday">
                              {endDateAr && endDateAr['day'] ? i18n.t(endDateAr['day']) : ''}
                            </div>
                            <div className="adn-date-value">
                              <Calendar size={18} />
                              {endDateAr && endDateAr['date'] ? endDateAr['date'] : '—'}
                            </div>
                            <div className="adn-date-time-val">({end_time})</div>
                          </div>
                        </div>

                        {/* Client */}
                        <div className="adn-hidden-sm">
                          <div className="adn-panel">
                            <div className="adn-panel-header">{i18n.t('client') || 'Client'}</div>
                            <div
                              className="adn-panel-body"
                              style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
                            >
                              <img
                                src={auction?.organizationDetails?.organization_image_url}
                                alt={auction?.organizationDetails?.organization_name || ''}
                                style={{
                                  width: 48,
                                  height: 48,
                                  borderRadius: '50%',
                                  objectFit: 'contain',
                                  border: '1.5px solid #e5e7eb',
                                  background: '#fafbfc',
                                }}
                              />
                              <div>
                                <div style={{ fontFamily: "'Sora', sans-serif", fontSize: 13, fontWeight: 700, color: '#1f2937' }}>
                                  {current_lng === 'ar'
                                    ? auction?.organizationDetails?.organization_name_ar
                                    : auction?.organizationDetails?.organization_name}
                                </div>
                                <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                  {current_lng === 'ar'
                                    ? auction?.organizationDetails?.description_ar
                                    : auction?.organizationDetails?.description}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ── Info strip — amounts ── */}
                      <div className="adn-info-strip container adn-info-strip--4col">
                        <div className="adn-panel">
                          <div className="adn-panel-header">{i18n.t('start_bid_amount')}</div>
                          <div className="adn-panel-body">
                            <div className="adn-amount-row">
                              <span className="adn-amount-val">
                                {formatCurrency(auction.start_amount)} <OmrRiyal />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="adn-panel">
                          <div className="adn-panel-header">{i18n.t('guarantee_amount')}</div>
                          <div className="adn-panel-body">
                            <div className="adn-amount-row">
                              <span className="adn-amount-val">
                                {formatCurrency(auction.guarantee_amount)} <OmrRiyal />
                              </span>
                            </div>
                          </div>
                        </div>

                        {Number(auction.visit_amount) > 0 && (
                          <div className="adn-panel">
                            <div className="adn-panel-header">{i18n.t('visit_amount')}</div>
                            <div className="adn-panel-body">
                              <div className="adn-amount-row">
                                <span className="adn-amount-val">
                                  {formatCurrency(auction.visit_amount)} <OmrRiyal />
                                </span>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="adn-panel">
                          <div className="adn-panel-header">{i18n.t('current_amount')}</div>
                          <div className="adn-panel-body">
                            <div className="adn-amount-row">
                              <span className="adn-amount-val">
                                {formatCurrency(auction.current_amount)} <OmrRiyal />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="adn-panel">
                          <div className="adn-panel-header">{i18n.t('category')}</div>
                          <div className="adn-panel-body">
                            <div className="adn-amount-row">
                              <span className="adn-amount-val">{category_name}</span>
                            </div>
                          </div>
                        </div>

                        <PropertyDetails auction={auction} />
                      </div>
                    </div>

                    {/* ── RIGHT SIDEBAR ── */}
                    <div className="adn-sidebar">
                      {/* Desktop sidebar — primary only on desktop screens */}
                      <div className="adn-hidden-sm">
                        <BiddingCompNew
                          auction={auction}
                          lng={current_lng}
                          onAmountUpdate={this.updateCurrentAmount}
                          isPrimary={!isMobile}
                        />
                      </div>


                      {auction.latitude && auction.longitude && (
                        <div className="adn-map-card">
                          <iframe
                            title="auction-location-map"
                            className="adn-map-iframe"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps?q=${parseFloat(auction.latitude)},${parseFloat(auction.longitude)}&z=15&output=embed`}
                          />
                          <a
                            href={`https://www.google.com/maps?q=${auction.latitude},${auction.longitude}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="adn-map-open-btn"
                          >
                            <i className="fa fa-map-marker" />
                            {i18n.t('open_google_map')}
                          </a>
                        </div>
                      )}

                      <AuctionAttachments auction={auction} />
                    </div>
                  </div>

                  {/* ══════════════════════════════════════════ */}
                  {/*  AUCTION SLIDER SECTIONS                   */}
                  {/* ══════════════════════════════════════════ */}

                  {/* Enrolled Auctions */}
                  {is_logged &&
                    !this.state.enrolledLoading &&
                    this.state.enrolledAuctions.length > 0 &&
                    this.renderSliderSection(
                      i18n.t('my_auctions'),
                      this.state.enrolledAuctions,
                      this.state.enrolledAuctions.length
                    )}

                  {/* Today Ending Auctions */}
                  {!this.state.todayLoading &&
                    this.state.todayAuctions.length > 0 &&
                    this.renderSliderSection(
                      i18n.t('today_ending'),
                      this.state.todayAuctions,
                      this.state.todayAuctions.length
                    )}

                  {/* Active Auctions */}
                  {sliderLoading && (
                    <div className="text-center p-4">
                      <div className="spinner-border text-secondary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}

                  {!sliderLoading && sliderAuctions.length > 0 && (
                    <div className="ad-related-section">
                      <div style={{ textAlign: 'center' }}>
                        <h2 className="ad-related-title">
                          {i18n.t('active_auctions')} &nbsp;
                          <span className="re-auc-topline__bids">{sliderAuctions.length}</span>
                        </h2>
                      </div>

                      <div className="as-slider-outer">
                        <button className="as-arrow as-arrow--left" onClick={this.slidePrev} disabled={currentIndex === 0}>
                          <ChevronLeft size={18} />
                        </button>

                        <div className="as-slider-track-wrap">
                          <div className="as-slider-track" style={{ transform: `translateX(${translateX}%)` }}>
                            {sliderAuctions.map((auc, i) =>
                              !auc.is_a_group ? (
                                <div key={auc.id || i} className="as-slide">
                                  <AuctionCardNew auction={auc} auctionId={auc.id} />
                                </div>
                              ) : (
                                <div key={i} className="as-slide">
                                  <AuctionGroupCardNew
                                    group={auc}
                                    total_items={sliderAuctions.length}
                                    can_bid={false}
                                    type={this.props.type}
                                  />
                                </div>
                              )
                            )}
                          </div>
                        </div>

                        <button className="as-arrow as-arrow--right" onClick={this.slideNext} disabled={currentIndex >= maxIndex}>
                          <ChevronRight size={18} />
                        </button>
                      </div>

                      {dotCount > 1 && (
                        <div className="as-dots">
                          {Array.from({ length: dotCount }).map((_, i) => (
                            <button
                              key={i}
                              className={`as-dot ${i === currentIndex ? 'as-dot--active' : ''}`}
                              onClick={() => this.setState({ currentIndex: i })}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </section>
            </>
          )}
        </div>
      </React.Fragment>
    );
  }
}

// React Router v6 wrapper
export function AuctionDetailsNewWrapper(props) {
  const params = useParams();
  const location = useLocation();
  return <AuctionDetailsNew {...props} match={{ params }} location={location} />;
}